var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[(_vm.user && _vm.ids.length)?_c('Map',{attrs:{"ids":_vm.ids}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }